import { bannerSlider } from "@omni/ui/brand/bannerSlider/bannerSlider.styles";
import { useImpressionTracking } from "@omni/ui/hooks/tracking/useImpressionTracking.hook";
import { ReactNode, useRef } from "react";

import { SliderContextProvider } from "@/components/BannerSlider/components/slider/context/slider.context";

import { useBannerSliderContext } from "../../context/bannerSlider.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Base = ({ className, children }: Props) => {
    const { trackingProps } = useBannerSliderContext();

    const { ref } = useImpressionTracking(trackingProps);

    const navigationPrevRef = useRef(null);
    const navigationNextRef = useRef(null);

    const { slider } = bannerSlider();

    return (
        <SliderContextProvider
            navigationNextRef={navigationNextRef}
            navigationPrevRef={navigationPrevRef}
        >
            <div
                className={slider({ className })}
                ref={ref}
            >
                {children}
            </div>
        </SliderContextProvider>
    );
};
